<template>
  <body>
    <!-- preloader -->
    <Loader> </Loader>
    <!-- preloader -->
 <Front-Header> </Front-Header>
<!-- company logo ----->
      <div>
    <div style="
    width: 100px;
">
   <p>Upload company logo</p>
      <input type="file" @change="previewImage" accept="image/*" >
   </div>
    <div>
      <p>Progress: {{uploadValue.toFixed()+"%"}}
      <progress id="progress" :value="uploadValue" max="100" ></progress>  </p>
    </div>
    <div v-if="imageData!=null">
        <img class="preview" :src="picture">
        <br>
      <button @click="onUpload">Upload</button>
    </div>
  </div>
  <!-- End of the company logo -->
  <!--company Hero image -->
         <div>
    <div style="
    width: 100px;
">
   <p>Upload company hero image</p>
      <input type="file" @change="previewImagech" accept="image/*" >
   </div>
    <div>
      <p>Progress: {{uploadValuech.toFixed()+"%"}}
      <progress id="progress" :value="uploadValuech" max="100" ></progress>  </p>
    </div>
    <div v-if="imageDatach!=null">
        <img class="preview" :src="picturech">
        <br>
      <button @click="onUploadch">Upload</button>
    </div>
  </div>
  <!--End company Hero image -->
  <!-- second section image ssi--->
    <div>
    <div style="
    width: 100px;
">
   <p>Upload image for second section</p>
      <input type="file" @change="previewImagechssi" accept="image/*" >
   </div>
    <div>
      <p>Progress: {{uploadValuechssi.toFixed()+"%"}}
      <progress id="progress" :value="uploadValuechssi" max="100" ></progress>  </p>
    </div>
    <div v-if="imageDatachssi!=null">
        <img class="preview" :src="picturechssi">
        <br>
      <button @click="onUploadchssi">Upload</button>
    </div>
  </div>
  <!-- End of the   second section image -->
      <div>
    <div style="
    width: 100px;
">
   <p>Upload image for second section</p>
      <input type="file" @change="previewImagechssitsi" accept="image/*" >
   </div>
    <div>
      <p>Progress: {{uploadValuechssitsi.toFixed()+"%"}}
      <progress id="progress" :value="uploadValuechssitsi" max="100" ></progress>  </p>
    </div>
    <div v-if="imageDatachssitsi!=null">
        <img class="preview" :src="picturechssitsi">
        <br>
      <button @click="onUploadchssitsi">Upload</button>
    </div>
  </div>
 <Front-Footer> </Front-Footer>
  </body>
</template>
<script>
import Header from "./Front-Header";
import Footer from "./Front-Footer";
import Loader from './Loader';
import firebase from 'firebase';

export default {
  components: {
    "Front-Header": Header,
    "Front-Footer": Footer,
    'Loader':Loader,
  },
  data(){
	return{
      imageData: null,
      picture: null,
      uploadValue: 0,    
	  imageDatach: null,
      picturech: null,
      uploadValuech: 0,
	  imageDatachssi: null,
      picturechssi: null,
      uploadValuechssitsi: 0,
	  imageDatachssitsi: null,
      picturechssitsi: null,
      uploadValuechssitsi: 0
	}
  },
  methods:{
    previewImage(event) {
      this.uploadValue=0;
      this.picture=null;
      this.imageData = event.target.files[0];console.log(this.imageData);
    },
    onUpload(){
      this.picture=null;
      const storageRef=firebase.storage().ref(this.imageData.name).put(this.imageData);
      storageRef.on('state_changed',snapshot=>{
        this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
      }, error=>{console.log(error.message)},
      ()=>{this.uploadValue=100;
        storageRef.snapshot.ref.getDownloadURL().then((url)=>{
          this.picture =url;
        });
      }
      );
    },
previewImagech(eventch) { 
  this.uploadValuech=0;
  this.picturech=null;
  this.imageDatach = eventch.target.files[0];
    },
    onUploadch(){
      this.picturech=null;
      const storageRefch=firebase.storage().ref(this.imageDatach.name).put(this.imageDatach);
      storageRefch.on('state_changed',snapshot=>{
        this.uploadValuech = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
      }, error=>{console.log(error.message)},
      ()=>{this.uploadValuech=100;
        storageRefch.snapshot.ref.getDownloadURL().then((url)=>{
          this.picturech =url;
        });
      }
      );
    },
	previewImagechssi(eventchssi) { 
	  this.uploadValuechssi=0;
	  this.picturechssi=null;
	  this.imageDatachssi = eventchssi.target.files[0];
    },
	onUploadchssi(){
      this.picturechssi=null;
      const storageRefchssi=firebase.storage().ref(this.imageDatachssi.name).put(this.imageDatachssi);
      storageRefchssi.on('state_changed',snapshot=>{
        this.uploadValuechssi = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
      }, error=>{console.log(error.message)},
      ()=>{this.uploadValuechssi=100;
        storageRefchssi.snapshot.ref.getDownloadURL().then((url)=>{
          this.picturechssi =url;
        });
      }
      );
    }


  }
}
</script>
<style scoped="">
img.preview {
    width: 200px;
}
</style>